<template>
  <v-content style="font-family: Microsoft JhengHei">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card class="elevation-12">
            <v-toolbar color="indigo darken-1" dark flat>
              <v-toolbar-title style="color: white">
                <!-- 1:{{formMapping.formId}}
                - 2:{{formMapping.targetId}}
                - 3:{{employer.employerId}}
                Application No：
                <span style="font-size:25px">{{formMapping.formKey}}</span>-->
                <label style="font-size: 1.5em">
                  標準局校園教學活動問卷調查表
                </label>
              </v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col cols="12" md="12">
                    <label style="font-size: 1.5em">
                      親愛的老師，您好：
                      <v-spacer />
                      感謝您參與並協助本次校園教學活動，煩請撥冗填答問卷，您的寶貴意見，將作為本局日後活動整體規劃與服務改善的重要參考，
                      謝謝！
                    </label>
                  </v-col>
                </v-row>
                <v-row>
                  <label style="font-size: 1.2em"> 一、基本資料： </label>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td style="width: 80px">活動日期 :</td>
                          <td>
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="teacherQuestionnaire.eventDate"
                                  readonly
                                  v-on="on"
                                  dense
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="teacherQuestionnaire.eventDate"
                                locale="zh-cn"
                                no-title
                                @input="menu = false"
                              ></v-date-picker>
                            </v-menu>
                          </td>
                          <td style="width: 80px"></td>
                          <td>學校 :</td>
                          <td>
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.school"
                            ></v-text-field>
                          </td>
                          <td>國小</td>
                        </tr>
                        <tr>
                          <td>老師姓名 :</td>
                          <td>
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.name"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td style="width: 80px">活動內容 :</td>
                          <td style="width: 180px">
                            <input
                              type="checkbox"
                              value="度量衡尋寶趣(中年級) "
                              v-model="eventContentArray"
                            />
                            度量衡尋寶趣(中年級)
                          </td>
                          <td style="width: 20px"></td>
                          <td style="width: 80px">參加人數 :</td>
                          <td>男</td>
                          <td style="width: 20px">
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.eventContentMale1"
                            ></v-text-field>
                          </td>
                          <td>人</td>
                          <td style="width: 20px"></td>
                          <td>女</td>
                          <td style="width: 20px">
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.eventContentFemale1"
                            ></v-text-field>
                          </td>
                          <td>人</td>
                        </tr>
                        <tr>
                          <td style="width: 80px"></td>
                          <td style="width: 180px">
                            <input
                              type="checkbox"
                              value="度量衡 SI 漂流記(高年級)"
                              v-model="eventContentArray"
                            />度量衡 SI 漂流記(高年級)
                          </td>
                          <td style="width: 20px"></td>
                          <td style="width: 80px">參加人數 :</td>
                          <td>男</td>
                          <td style="width: 20px">
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.eventContentMale2"
                            ></v-text-field>
                          </td>
                          <td>人</td>
                          <td style="width: 20px"></td>
                          <td>女</td>
                          <td style="width: 20px">
                            <v-text-field
                              type="text"
                              dense
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.eventContentFemale2"
                            ></v-text-field>
                          </td>
                          <td>人</td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <label style="font-size: 1.2em"> 二、滿意度調查 </label>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>1.老師專業知識程度……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck1"
                              v-model="satisfaction1Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck1"
                              v-model="satisfaction1Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck1"
                              v-model="satisfaction1Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other1"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>2.老師表達技巧……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck2"
                              v-model="satisfaction2Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck2"
                              v-model="satisfaction2Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck2"
                              v-model="satisfaction2Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other2"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>3.教材及活動內容的滿意度……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck3"
                              v-model="satisfaction3Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck3"
                              v-model="satisfaction3Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck3"
                              v-model="satisfaction3Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other3"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>4.教學活動方式設計……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck4"
                              v-model="satisfaction4Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck4"
                              v-model="satisfaction4Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck4"
                              v-model="satisfaction4Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other4"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>5.時間掌控 ……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck5"
                              v-model="satisfaction5Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck5"
                              v-model="satisfaction5Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck5"
                              v-model="satisfaction5Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other5"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>6.老師與學員互動效果……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck6"
                              v-model="satisfaction6Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck6"
                              v-model="satisfaction6Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck6"
                              v-model="satisfaction6Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other6"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>7.活動內容對小朋友的幫助 ……</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck7"
                              v-model="satisfaction7Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck7"
                              v-model="satisfaction7Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck7"
                              v-model="satisfaction7Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other7"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>8.是否達到您的預期效果………</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck8"
                              v-model="satisfaction8Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck8"
                              v-model="satisfaction8Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck8"
                              v-model="satisfaction8Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other8"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>9.桌遊遊戲設計方式(中年級免填)…</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck9"
                              v-model="satisfaction9Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck9"
                              v-model="satisfaction9Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck9"
                              v-model="satisfaction9Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other9"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>10.桌遊遊戲對小朋友學習的幫助(中年級免填)</td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="滿意"
                              @change="uniqueCheck10"
                              v-model="satisfaction10Array"
                            />
                            滿意
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="普通"
                              @change="uniqueCheck10"
                              v-model="satisfaction10Array"
                            />
                            普通
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="不滿意"
                              @change="uniqueCheck10"
                              v-model="satisfaction10Array"
                            />
                            不滿意，
                          </td>
                          <td>
                            <v-text-field
                              v-model="other10"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>
                            11.如果標準檢驗局明年繼續舉辦類似活動，您是否有意願報名參加
                          </td>
                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="是"
                              @change="uniqueCheck11"
                              v-model="satisfaction11Array"
                            />
                            是
                          </td>

                          <td style="width: 80px">
                            <input
                              type="checkbox"
                              value="否"
                              @change="uniqueCheck11"
                              v-model="satisfaction11Array"
                            />
                            否
                          </td>

                          <td>
                            <v-text-field
                              v-model="other11"
                              label="原因"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <label style="font-size: 1.2em"> 三、其他意見： </label>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>1.我認為本次活動可再調整的內容是：</td>
                          <td>
                            <v-text-field
                              type="text"
                              style="width: 300px"
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.opinion1"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>2.建議下次可辦理與度量衡相關之主題與方式：</td>
                          <td>
                            <v-text-field
                              type="text"
                              style="width: 300px"
                              class="font-weight-normal"
                              v-model="teacherQuestionnaire.opinion2"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>
                            3.對於現行國小教科書所使用之度量衡單位是否有任何意見：
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <v-textarea
                              type="text"
                              style="width: 600px"
                              class="font-weight-normal"
                              counter
                              v-model="teacherQuestionnaire.opinion3"
                            ></v-textarea>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-table>
                      <tbody>
                        <tr>
                          <td>4.其他意見與建議：</td>
                        </tr>
                        <tr>
                          <td>
                            <v-textarea
                              type="text"
                              style="width: 600px"
                              class="font-weight-normal"
                              counter
                              v-model="teacherQuestionnaire.opinion4"
                            ></v-textarea>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <!-- 
            <v-card-actions class="hidden-sm-and-down">
              <v-spacer></v-spacer>

              <v-btn
                color="teal"
                style="color: white"
                class="ma-2"
                large
                @click="submitObject()"
              >
                <v-avatar left> <v-icon>mdi-check</v-icon> </v-avatar>送出
              </v-btn>
            </v-card-actions> -->
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="teal"
                style="color: white"
                class="ma-2"
                large
                @click="submitObject()"
              >
                <v-avatar left> <v-icon>mdi-check</v-icon> </v-avatar>送出
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogNote" width="800px">
      <NoteComponents
        :noteItem="noteItem"
        v-on:childDialog="parentDialog"
      ></NoteComponents>
    </v-dialog>
    <div v-if="dialogEmployerVacancies">
      <v-dialog persistent v-model="dialogEmployerVacancies" width="800px">
        <EmployerVacanciesComponents
          :selectItem="targetEmployerVacancies"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateVacancies"
          v-on:remove-item="removeVacancies"
        ></EmployerVacanciesComponents>
      </v-dialog>
    </div>
    <div v-if="dialogEmployerTerminated">
      <v-dialog persistent v-model="dialogEmployerTerminated" width="800px">
        <EmployerTerminatedComponents
          :selectItem="targetEmployerTerminated"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateTerminated"
          v-on:remove-item="removeTerminated"
        ></EmployerTerminatedComponents>
      </v-dialog>
    </div>
    <div v-if="dialogContinue">
      <v-dialog persistent v-model="dialogContinue" width="600px">
        <ContinueKeyComponents
          :selectItem="continueKey"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateContinueKey"
        ></ContinueKeyComponents>
      </v-dialog>
    </div>
    <div v-if="dialogEntrance">
      <v-dialog persistent v-model="dialogEntrance" width="600px">
        <ContinueKeyComponents
          :selectItem="continueKey"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateContinueKey"
        ></ContinueKeyComponents>
      </v-dialog>
    </div>
  </v-content>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import swal from "sweetalert2";

import { mapGetters, mapActions } from "vuex";
import NoteComponents from "../Common/NoteComponents";
import EmployerVacanciesComponents from "../Common/EmployerVacanciesComponents";
import EmployerTerminatedComponents from "../Common/EmployerTerminatedComponents";
import ContinueKeyComponents from "../Common/ContinueKeyComponents";
import EntranceComponents from "../Common/EntranceComponents";
import ButtonFooterComponents from "../Common/ButtonFooterComponents";

import Vue from "vue";

export default {
  components: {
    NoteComponents,
    EmployerVacanciesComponents,
    EmployerTerminatedComponents,
    ContinueKeyComponents,
  },
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"],
    }),
    readOnlyFlag() {
      var vm = this;
      if (vm.formMapping.status == "S") {
        return true;
      } else return false;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  data() {
    return {
      deptArray: [],
      jobArray: [],
      opinionArray: [],
      genderArray: [],
      eventContentArray: [],
      satisfaction1Array: [],
      satisfaction2Array: [],
      satisfaction3Array: [],
      satisfaction4Array: [],
      satisfaction5Array: [],
      satisfaction6Array: [],
      satisfaction7Array: [],
      satisfaction8Array: [],
      satisfaction9Array: [],
      satisfaction10Array: [],
      satisfaction11Array: [],

      causeArray: [],
      other: null,
      other1: null,
      other2: null,

      other3: null,
      other4: null,
      other5: null,
      other6: null,
      other7: null,
      other8: null,
      other9: null,
      other10: null,
      other11: null,

      date: new Date().toISOString().substr(0, 10),
      startDate2: null,
      endDate2: null,
      dialog2: false,
      menu: false,
      menuS: false,
      menuE: false,
      enabled: false,

      valid: true,
      dialogEmployerVacancies: false,
      dialogEmployerTerminated: false,
      dialogContinue: false,
      dialogEntrance: false,
      dialogNote: false,
      continueKey: null,
      formMapping: this.getlesModel("formMapping"),
      teacherQuestionnaire: this.getlesModel("teacherQuestionnaire"),
      employerTerminatedList: [],
      employerVacanciesList: [],
      targetEmployerVacancies: this.getlesModel("employerVacancies"),
      targetEmployerTerminated: this.getlesModel("employerTerminated"),
      headers: {
        employerVacanciesHeaders: [
          { text: "Job Title", value: "jobTitle", width: 60 },
          { text: "No. of Vacancies", value: "vacanciesNumber", width: 15 },
          {
            text: "Qualifications Required",
            value: "qualifications",
            width: 20,
          },
          { text: "Location of Vacancy", value: "location", width: 15 },
          { text: "No. of Weekly Working Hours", value: "hours", width: 10 },
          { text: "Start Date", value: "startDate", width: 20 },
        ],
        employerTerminatedHeaders: [
          { text: "Name", value: "name", width: 50 },
          { text: "Job Title", value: "jobTitle", width: 50 },
          // {
          //   text: "Phone No.",
          //   value: "phone",
          //   width: 10
          // },
          // {
          //   text: "Email",
          //   value: "email",
          //   width: 10
          // },
          { text: "Date of Employment", value: "dateOfEmployment", width: 10 },
          {
            text: "Date of Termination",
            value: "dateOfTermination",
            width: 10,
          },
          { text: "Salary", value: "salary", width: 10 },
          {
            text: "Indicate how Worker's salary was fixed",
            value: "paymentMethods",
            width: 20,
          },
        ],
      },
      noteItem: {},
      notes: {
        note1: {
          title: "Current Business Status",
          contentArray: [
            "Fully Closed : Business ceased operations",
            "Temporary Closed : Business closed for six (6) months or less",
            "Partialy Closed : Only some sections/departments of the business are operating",
            "Fully Operational : All sections/departments are operating",
          ],
        },
        note2: {
          title: "Entrance",
          contentArray: [
            "New Application : create a new application and get a new Application No.",
            "Resume : Use Application No. to fill in the form",
          ],
        },
      },
      inputRules: {
        numberRule: (val) => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }

          var r = /^\+?[1-9][0-9]*$/;
          if (!r.test(val) || val < 0) {
            return "Please enter Positive Integer";
          }

          // if (val < 0) {
          //   return "Please enter a positive number";
          // }
          return true;
        },
        emailRule: (val) => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(val) || "Invalid e-mail.";
        },
      },
    };
  },
  // watch: {
  //   isAppIdle: "autoSaveObject",
  // },
  methods: {
    ...mapActions(["updateAutoSaveStatus"]),
    parentDialog() {
      var vm = this;
      vm.dialogEmployerVacancies = false;
      vm.dialogEmployerTerminated = false;
      vm.dialogContinue = false;
      vm.dialogNote = false;
      vm.dialogEntrance = false;

      if ("entrance" == vm.$route.params.formKey) {
        vm.dialogEntrance = !vm.dialogEntrance;
        vm.noteItem = vm.notes.note2;
      }
    },
    buttonType(type) {
      this.$emit("update-item", type);
    },
    uniqueCheck(e) {
      this.eventContentArray = [];
      if (e.target.checked) {
        this.eventContentArray.push(e.target.value);
      }
    },
    uniqueCheck1(e) {
      this.satisfaction1Array = [];
      if (e.target.checked) {
        this.satisfaction1Array.push(e.target.value);
      }
    },
    uniqueCheck2(e) {
      this.satisfaction2Array = [];
      if (e.target.checked) {
        this.satisfaction2Array.push(e.target.value);
      }
    },
    uniqueCheck3(e) {
      this.satisfaction3Array = [];
      if (e.target.checked) {
        this.satisfaction3Array.push(e.target.value);
      }
    },
    uniqueCheck4(e) {
      this.satisfaction4Array = [];
      if (e.target.checked) {
        this.satisfaction4Array.push(e.target.value);
      }
    },
    uniqueCheck5(e) {
      this.satisfaction5Array = [];
      if (e.target.checked) {
        this.satisfaction5Array.push(e.target.value);
      }
    },
    uniqueCheck6(e) {
      this.satisfaction6Array = [];
      if (e.target.checked) {
        this.satisfaction6Array.push(e.target.value);
      }
    },
    uniqueCheck7(e) {
      this.satisfaction7Array = [];
      if (e.target.checked) {
        this.satisfaction7Array.push(e.target.value);
      }
    },
    uniqueCheck8(e) {
      this.satisfaction8Array = [];
      if (e.target.checked) {
        this.satisfaction8Array.push(e.target.value);
      }
    },
    uniqueCheck9(e) {
      this.satisfaction9Array = [];
      if (e.target.checked) {
        this.satisfaction9Array.push(e.target.value);
      }
    },
    uniqueCheck10(e) {
      this.satisfaction10Array = [];
      if (e.target.checked) {
        this.satisfaction10Array.push(e.target.value);
      }
    },
    uniqueCheck11(e) {
      this.satisfaction11Array = [];
      if (e.target.checked) {
        this.satisfaction11Array.push(e.target.value);
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    submitObject() {
      var vm = this;

      //vm.formMapping.status = "S";
      // vm.employer.status = "S";
      vm.updateApiData().then((result2) => {
        // console.log("result2 " + result2);
        if (result2 != "ERROR") vm.successSwalUtil();
      });
    },
    tempObject() {
      var vm = this;
      vm.updateApiData().then((result2) => {
        // console.log("result2 " + result2);
        if (result2 != "ERROR") vm.successSwalUtil();
      });
    },
    updateVacancies(targetItem) {
      var vm = this;
      vm.dialogEmployerVacancies = false;

      if (targetItem.vacanciesId == "init") {
        var date = new Date();
        targetItem.vacanciesId =
          "init" +
          date.getFullYear() +
          date.getMonth() +
          1 +
          date.getDate() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds();
        vm.employerVacanciesList.push(targetItem);
      } else {
        vm.employerVacanciesList.forEach(function (item, index, array) {
          if (item.vacanciesId == targetItem.vacanciesId) {
            vm.employerVacanciesList.splice(index, 1, targetItem);
          }
        });
      }
    },
    removeVacancies(targetItem) {
      var vm = this;
      vm.dialogEmployerVacancies = false;
      vm.employerVacanciesList.forEach(function (item, index, array) {
        if (item.vacanciesId == targetItem.vacanciesId) {
          vm.employerVacanciesList.splice(index, 1);
        }
      });
    },
    updateTerminated(targetItem) {
      var vm = this;
      vm.dialogEmployerTerminated = false;

      if (targetItem.terminatedId == "init") {
        var date = new Date();
        targetItem.terminatedId =
          "init" +
          date.getFullYear() +
          date.getMonth() +
          1 +
          date.getDate() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds();
        vm.employerTerminatedList.push(targetItem);
      } else {
        vm.employerTerminatedList.forEach(function (item, index, array) {
          if (item.terminatedId == targetItem.terminatedId) {
            vm.employerTerminatedList.splice(index, 1, targetItem);
          }
        });
      }
    },
    removeTerminated(targetItem) {
      var vm = this;
      vm.dialogEmployerTerminated = false;
      vm.employerTerminatedList.forEach(function (item, index, array) {
        if (item.terminatedId == targetItem.terminatedId) {
          vm.employerTerminatedList.splice(index, 1);
        }
      });
    },
    updateContinueKey(value) {
      var vm = this;
      vm.$router.push({
        path: "/FormEmployer/" + value,
      });
      // vm.continueObject(value);
      // console.log("updateContinueKey value " + value);
    },
    updateEntrance(value) {
      var vm = this;
      if (value == "init") {
        vm.$router.push({
          path: "/FormEmployer/init",
        });
      } else if (value == "continue") {
        vm.dialogContinue = !vm.dialogContinue;
      }
      this.dialogEntrance = false;
    },
    // autoSaveObject() {
    //   var vm = this;
    //   // console.log(" vm.formMapping " + vm.formMapping.formId);

    //   if (
    //     vm.formMapping.formId == null ||
    //     vm.formMapping.status == "S" ||
    //     !vm.valid ||
    //     vm.dialogEmployerVacancies ||
    //     vm.dialogEmployerTerminated ||
    //     vm.dialogContinue ||
    //     vm.dialogEntrance ||
    //     vm.dialogNote
    //   ) {
    //     return;
    //   }
    //   if (this.isAppIdle) {
    //     vm.updateApiData();
    //   } else {
    //     // vm.updateAutoSaveStatus("N");
    //   }
    // },
    updateApiData() {
      var vm = this;
      // delete vm.employer.employerTerminatedSet;
      // delete vm.employer.employerVacanciesSet;
      //var visitDateValue = vm.homework.visitDate;
      // var phoneValue = vm.employer.phone;
      var flag = true;

      // if (vm.causeArray.length == 0) {
      //   flag = false;

      //   swal("請輸入有無被疫調");
      // }
      // if (vm.healthArray.length == 0) {
      //   flag = false;

      //   swal("請輸入健康狀況");
      // }
      if (vm.teacherQuestionnaire.eventDate == null) {
        flag = false;

        swal("請輸入活動日期");
      }
      if (vm.teacherQuestionnaire.school == null) {
        flag = false;

        swal("請輸入學校");
      }
      if (vm.teacherQuestionnaire.name == null) {
        flag = false;

        swal("請輸入姓名");
      }
      // if (vm.homework.dept == null) {
      //   flag = false;

      //   swal("請輸入單位");
      // }
      // if (visitDateValue == null) {
      //   flag = false;

      //   swal("請輸入日期");
      // }

      // if (phoneValue == null) {
      //   flag = false;

      //   swal("請輸入聯絡方式");
      // }
      // vm.employer.startDate = vm.employer.startDate.substr("0", "5");
      // vm.employer.endDate = vm.employer.endDate.substr("0", "5");
      var timeStr1 = "";
      var timeStr2 = "";
      var timeStr3 = "";
      var timeStr4 = "";
      var timeStr5 = "";
      var timeStr6 = "";
      var timeStr7 = "";
      var timeStr8 = "";
      var timeStr9 = "";
      var timeStr10 = "";
      var timeStr11 = "";

      vm.teacherQuestionnaire.opinion = "";
      vm.teacherQuestionnaire.eventContent = "";

      // if (this.opinionArray != null) {
      //   for (let a = 0; a < this.opinionArray.length; a++) {
      //     vm.teacherQuestionnaire.opinion += this.opinionArray[a] + ";";
      //   }
      // }

      if (this.eventContentArray != null) {
        for (let a = 0; a < this.eventContentArray.length; a++) {
          vm.teacherQuestionnaire.eventContent +=
            this.eventContentArray[a] + "，";
        }
        vm.teacherQuestionnaire.eventContent =
          vm.teacherQuestionnaire.eventContent.substring(
            0,
            vm.teacherQuestionnaire.eventContent.length - 1
          );
      }
      if (this.satisfaction1Array != null) {
        for (let a = 0; a < this.satisfaction1Array.length; a++) {
          timeStr1 = this.satisfaction1Array[a];
        }
        if (timeStr1 == "不滿意") {
          var o1 = this.other1 == null ? "" : this.other1;
          vm.teacherQuestionnaire.satisfaction1 = "不滿意，" + o1;
        } else {
          vm.teacherQuestionnaire.satisfaction1 = timeStr1;
        }
      }

      if (this.satisfaction2Array != null) {
        for (let a = 0; a < this.satisfaction2Array.length; a++) {
          timeStr2 = this.satisfaction2Array[a];
        }
        if (timeStr2 == "不滿意") {
          var o2 = this.other2 == null ? "" : this.other2;
          vm.teacherQuestionnaire.satisfaction2 = "不滿意，" + o2;
        } else {
          vm.teacherQuestionnaire.satisfaction2 = timeStr2;
        }
      }
      if (this.satisfaction3Array != null) {
        for (let a = 0; a < this.satisfaction3Array.length; a++) {
          timeStr3 = this.satisfaction3Array[a];
        }
        if (timeStr3 == "不滿意") {
          var o3 = this.other3 == null ? "" : this.other3;
          vm.teacherQuestionnaire.satisfaction3 = "不滿意，" + o3;
        } else {
          vm.teacherQuestionnaire.satisfaction3 = timeStr3;
        }
      }
      if (this.satisfaction4Array != null) {
        for (let a = 0; a < this.satisfaction4Array.length; a++) {
          timeStr4 = this.satisfaction4Array[a];
        }
        if (timeStr4 == "不滿意") {
          var o4 = this.other4 == null ? "" : this.other4;
          vm.teacherQuestionnaire.satisfaction4 = "不滿意，" + o4;
        } else {
          vm.teacherQuestionnaire.satisfaction4 = timeStr4;
        }
      }
      if (this.satisfaction5Array != null) {
        for (let a = 0; a < this.satisfaction5Array.length; a++) {
          timeStr5 = this.satisfaction5Array[a];
        }
        if (timeStr5 == "不滿意") {
          var o5 = this.other5 == null ? "" : this.other5;
          vm.teacherQuestionnaire.satisfaction5 = "不滿意，" + o5;
        } else {
          vm.teacherQuestionnaire.satisfaction5 = timeStr5;
        }
      }
      if (this.satisfaction6Array != null) {
        for (let a = 0; a < this.satisfaction6Array.length; a++) {
          timeStr6 = this.satisfaction6Array[a];
        }
        if (timeStr6 == "不滿意") {
          var o6 = this.other6 == null ? "" : this.other6;
          vm.teacherQuestionnaire.satisfaction6 = "不滿意，" + o6;
        } else {
          vm.teacherQuestionnaire.satisfaction6 = timeStr6;
        }
      }
      if (this.satisfaction7Array != null) {
        for (let a = 0; a < this.satisfaction7Array.length; a++) {
          timeStr7 = this.satisfaction7Array[a];
        }
        if (timeStr7 == "不滿意") {
          var o7 = this.other7 == null ? "" : this.other7;
          vm.teacherQuestionnaire.satisfaction7 = "不滿意，" + o7;
        } else {
          vm.teacherQuestionnaire.satisfaction7 = timeStr7;
        }
      }
      if (this.satisfaction8Array != null) {
        for (let a = 0; a < this.satisfaction8Array.length; a++) {
          timeStr8 = this.satisfaction8Array[a];
        }
        if (timeStr8 == "不滿意") {
          var o8 = this.other8 == null ? "" : this.other8;
          vm.teacherQuestionnaire.satisfaction8 = "不滿意，" + o8;
        } else {
          vm.teacherQuestionnaire.satisfaction8 = timeStr8;
        }
      }
      if (this.satisfaction9Array != null) {
        for (let a = 0; a < this.satisfaction9Array.length; a++) {
          timeStr9 = this.satisfaction9Array[a];
        }
        if (timeStr9 == "不滿意") {
          var o9 = this.other9 == null ? "" : this.other9;
          vm.teacherQuestionnaire.satisfaction9 = "不滿意，" + o9;
        } else {
          vm.teacherQuestionnaire.satisfaction9 = timeStr9;
        }
      }
      if (this.satisfaction10Array != null) {
        for (let a = 0; a < this.satisfaction10Array.length; a++) {
          timeStr10 = this.satisfaction10Array[a];
        }
        if (timeStr10 == "不滿意") {
          var o10 = this.other10 == null ? "" : this.other10;
          vm.teacherQuestionnaire.satisfaction10 = "不滿意，" + o10;
        } else {
          vm.teacherQuestionnaire.satisfaction10 = timeStr10;
        }
      }

      if (this.satisfaction11Array != null) {
        for (let a = 0; a < this.satisfaction11Array.length; a++) {
          timeStr11 = this.satisfaction11Array[a];
        }
        if (timeStr11 == "否") {
          var o11 = this.other11 == null ? "" : this.other11;
          vm.teacherQuestionnaire.satisfaction11 = "否，" + o11;
        } else {
          vm.teacherQuestionnaire.satisfaction11 = timeStr11;
        }
      }
      var data = vm.teacherQuestionnaire;
      if (flag) {
        var foo = vm.axios
          .post(vm.idbServerUrl + "les/form/teacherQuestionnaireAdd", data, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(function (response) {
            swal("已完成問卷!");
            // vm.$router.push({
            //   path: "/homeworkDisplay/" + response.data.uuid,
            // });
          })
          .catch(function (error) {
            vm.handErrorUtil(error);
            //   vm.formMapping.status = "T";
            vm.employer.status = "T";
            console.log("!!!! " + error);
            return "ERROR";
          });
        return foo;
      } else {
        // vm.newObject();
      }
    },
    // newObject() {
    //   var vm = this;
    //   //vm.employer.employerId = "init";

    //   var data = "FORM_EMPLOYER";
    //   vm.axios
    //     .post(vm.idbServerUrl + "les/form/studentQuestionnaireAdd", data, {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then(function (response) {
    //       vm.formMapping = response.data;
    //     })
    //     .catch(function (error) {
    //       vm.handErrorUtil(error);
    //       console.log("!!!! " + error);
    //     });
    // },
    continueObject(value) {
      var vm = this;

      vm.axios
        .get(vm.idbServerUrl + "les/form/lesForm/" + value, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          console.log("response " + JSON.stringify(response.data));
          if (response.data.formMapping == null) {
            vm.NotFindApplicationUtil(value);

            return;
          }
          vm.formMapping = response.data.formMapping;
          vm.employer = response.data.employerBean.employer;
          vm.employerTerminatedList =
            response.data.employerBean.employerTerminatedList;
          vm.employerVacanciesList =
            response.data.employerBean.employerVacanciesList;
          vm.employerTerminatedList.forEach((result) => {
            result.dateOfEmployment = vm.convertDBDateToString(
              result.dateOfEmployment
            );
            result.dateOfTermination = vm.convertDBDateToString(
              result.dateOfTermination
            );
          });
          vm.employerVacanciesList.forEach((result) => {
            result.startDate = vm.convertDBDateToString(result.startDate);
          });
          // console.log("SUCCESS!!!!!!! ");
        })
        .catch(function (error) {
          vm.handErrorUtil(error);
        });
    },
    updateButtonObject(type) {
      let vm = this;
      console.log("type " + type);
      if ("Entrance" == type) {
        vm.updateContinueKey("entrance");
      } else if ("Resume" == type) {
        vm.dialogContinue = !vm.dialogContinue;
      } else if ("Submit" == type) {
        vm.submitObject();
      } else if ("Temp" == type) {
        vm.tempObject();
      }
    },
  },
  mounted() {
    let vm = this;

    vm.deptArray = vm.getCodeDateUtil("deptForHome");
    vm.jobArray = vm.getCodeDateUtil("jobForHome");

    // if ("init" == vm.$route.params.formKey) {
    //   vm.newObject();
    // } else if ("entrance" == vm.$route.params.formKey) {
    //   vm.dialogEntrance = !vm.dialogEntrance;
    //   vm.noteItem = vm.notes.note2;
    // } else {
    //   vm.continueObject(vm.$route.params.formKey);
    // }
    // this.employerVacanciesList.push({
    //   hours: 12,
    //   jobTitle: "Accountants",
    //   location: "Caye Caulker Village",
    //   qualifications: "Bachelor's Degree",
    //   startDate: "2020-03-05",
    //   vacanciesId: "1223477",
    //   vacanciesNumber: 3
    // });
    // this.employerTerminatedList.push({
    //   dateOfEmployment: "2020-03-05",
    //   dateOfTermination: "2020-03-05",
    //   email: "jugan.74111@gmail.com",
    //   jobTitle: "Administrative and executive secretaries",
    //   name: "周欣翰111",
    //   paymentMethods: "Commission",
    //   phone: "0963555802",
    //   salary: "12213"
    // });
  },
  created() {
    let vm = this;

    // console.log("!!!!!!!! " + vm.$route.params.formKey);
  },
  beforeDestroy() {},
};
</script>




